module.exports = __webpack_public_path__ + "assets/operator-app-white.90bdd5ec.svg";